import i18n from 'i18next';
i18n.init();

// Mirror of const definitions in /wb/protected/models/Metric.php
// Define the const for measure metric data
export const MEASURE_METRIC_DATA_TOTAL = 1;
export const MEASURE_METRIC_DATA_AVERAGE = 2;
export const MEASURE_METRIC_DATA_PROGRESS = 3; // average
export const MEASURE_METRIC_DATA_SUM_PROGRESS = 4;
export const MEASURE_METRIC_DATA_TOTAL_ACHIEVED_VALUES = 5; // Total of achieved values
export const MEASURE_METRIC_DATA_AVG_ACHIEVED_VALUES = 6; // Average of achieved values
export const MEASURE_METRIC_DATA_AVG_PROGRESS_PERCENTAGE = 7; // Average of cascade progress percentages

export const IntervalTexts = {
  1: i18n.t('Daily'),
  2: i18n.t('Weekly'),
  3: i18n.t('Monthly'),
  4: i18n.t('Quarterly'),
  5: i18n.t('Once'),
  6: i18n.t('Bi-Weekly'),
  7: i18n.t('Bi-Quarterly'),
}

const IntervalOptions = () => [
  {
    value: 1,
    name: i18n.t('Daily'),
  },
  {
    value: 2,
    name: i18n.t('Weekly'),
  },
  {
    value: 3,
    name: i18n.t('Monthly'),
  },
  {
    value: 4,
    name: i18n.t('Quarterly'),
  },
]

export const WeekDaysOptionsText = () => ({
  1: i18n.t('Monday'),
  2: i18n.t('Tuesday'),
  3: i18n.t('Wednesday'),
  4: i18n.t('Thursday'),
  5: i18n.t('Friday'),
  6: i18n.t('Saturday'),
  7: i18n.t('Sunday'),
})

 const WeekDaysOptions = () => [
  {
    value: 1,
    name: i18n.t('Monday'),
  },
  {
    value: 2,
    name: i18n.t('Tuesday'),
  },
  {
    value: 3,
    name: i18n.t('Wednesday'),
  },
  {
    value: 4,
    name: i18n.t('Thursday'),
  },
  {
    value: 5,
    name: i18n.t('Friday'),
  },
  {
    value: 6,
    name: i18n.t('Saturday'),
  },
  {
    value: 7,
    name: i18n.t('Sunday'),
  },
]
const MeasureDataOptions = [
  {
    value: 1,
    name: i18n.t('Last entered value'),
  },
  {
    value: 4,
    name: i18n.t('Progress percentage'),
  },
]
const MeasureDataOptionsLower = [
  {
    value: 1,
    name: i18n.t('Last entered value'),
  },
]

const CalculationProgressOption = [
  {
    value: 3,
    name: i18n.t('Average progress percentages'),
  },
  /* {
        value: 4,
        name: "Total of progress percentages"
    }, */
  {
    value: 5,
    name: i18n.t('Total of achieved values'),
  },
  {
    value: 6,
    name: i18n.t('Average of achieved values'),
  },
  {
    value: 1,
    name: i18n.t('Total of latest updates'),
  },
  {
    value: 2,
    name: i18n.t('Average of latest updates'),
  },
]

const CalculationCascadeProgressOption = [
  {
    value: 1,
    name: i18n.t('Total of all values over time'),
  },
  {
    value: 2,
    name: i18n.t('Weekly average of values'),
  },
  {
    value: 5,
    name: i18n.t('Total of Actuals'),
  },
  {
    value: 6,
    name: i18n.t('Average of Actuals'),
  },
  {
    value: 7,
    name: i18n.t('Average Progress %'),
  }
]

const CalculationProgressOptionLower = [
  {
    value: 5,
    name: i18n.t('Total of achieved values'),
  },
  {
    value: 6,
    name: i18n.t('Average of achieved values'),
  },
  {
    value: 1,
    name: i18n.t('Total of latest updates'),
  },
  {
    value: 2,
    name: i18n.t('Average of latest updates'),
  },
]
let localeJsonValue = localeJsonValue ? localeJsonValue : {}
const ProgressTypeOptions = [
  {
    value: 1,
    name: i18n.t('Last entered value'),
  },
  {
    value: 2,
    name: `${i18n.t('Total of all')} ${
      localeJsonValue['key result'] ? localeJsonValue['key result'] : i18n.t('entered')
    } ${i18n.t('values')}`,
  },
  {
    value: 3,
    name: `${i18n.t('Average of all')} ${
      localeJsonValue['key result'] ? localeJsonValue['key result'] : i18n.t('entered')
    } ${i18n.t('values')}`,
  },
]

const ProgressTypeCascadeOptions = [
  {
    value: 1,
    name: i18n.t('Last entered value'),
  },
  {
    value: 2,
    name: i18n.t('Total of all entered values'),
  },
]

const MetricTypeOptions = [
  {
    value: 1,
    name: i18n.t('Number'),
  },
  {
    value: 2,
    name: i18n.t('Currency'),
  },
  {
    value: 3,
    name: i18n.t('Percentage'),
  },
]

const YesOrNoOptions = [
  {
    value: 1,
    name: i18n.t('Number of Yes'),
  },
  {
    value: 2,
    name: i18n.t('Number of No'),
  },
  {
    value: 3,
    name: i18n.t('Percentage of Yes'),
  },
  {
    value: 4,
    name: i18n.t('Percentage of No'),
  },
]

const CountingOptions = [
  {
    value: 7,
    name: i18n.t('Counting as number'),
  },
  {
    value: 8,
    name: i18n.t('Counting as currency'),
  },
  {
    value: 9,
    name: i18n.t('Counting as percentage'),
  },
]

const CountingTargetOptions = [
  {
    value: 1,
    name: i18n.t('Should increase to'),
    icon: 'icon icon-outline-arrow_upward-18px-blue',
  },
  {
    value: 2,
    name: i18n.t('Should decrease to'),
    icon: 'icon icon-outline-arrow_downward-18px-blue',
  },
  {
    value: 3,
    name: i18n.t('Should be equal to'),
    icon: 'icon icon-exact-18px-blue',
  },
  {
    value: 4,
    name: i18n.t('Should fall within a range'),
    icon: 'icon icon-outline-arrow_range-18px-blue',
  },
  {
    value: 8,
    name: i18n.t('Should not exceed'),
  },
  {
    value: 9,
    name: i18n.t('Should not fall below'),
  },
]

const CascadeProgressTypeOptions = [
  {
    value: 2,
    name: i18n.t('Total of all values over time'),
  },
  {
    value: 3,
    name: i18n.t('Weekly average of values'),
  },
]

export const cascadeProgressTypeOptionsText = (text) => {
  if (text) {
    const cascadeProgressTypeOptionsAppent = [
      {
        value: 2,
        name: i18n.t('Total of all values over time'),
      },
      {
        value: 3,
        name: `${text} ${i18n.t('average of values')}`,
      },
    ]
    return cascadeProgressTypeOptionsAppent
  }
  return getCascadeProgressTypeOptions()
}

export const getIntervalText = (id, lowerCase = false) => {
  const text = typeof IntervalTexts[id] !== 'undefined' ? IntervalTexts[id] : ''
  if (lowerCase) {
    return text.toLowerCase()
  }
  return text
}
export const getMeasureDataOptions = (type = '') => {
  // console.log('type',type);
  if (type == 'lower') {
    // console.log('type',type);
    return MeasureDataOptionsLower
  }

  return MeasureDataOptions
}
export const getCalculationProgressOption = (type = '') => {
  // console.log('new type',type);
  const CalculationProgressOption = [
    /* {
          value: 4,
          name: "Total of progress percentages"
      }, */
    {
      value: 5,
      name: i18n.t('Total of results'),
    },
    {
      value: 6,
      name: i18n.t('Average of results'),
    },
    {
      value: 3,
      name: i18n.t('Average of completion percentages'),
    },
    {
      value: 1,
      name: i18n.t('Total of latest updates'),
    },
    {
      value: 2,
      name: i18n.t('Average of latest updates'),
    },
  ]

  if (type == 'new') {
    return CalculationProgressOption.filter(
      (f) => f.value == '5' || f.value == '6' || f.value == '3'
    )
  }
  if (type == 'multiple') {
    return CalculationProgressOption
  }
  if (type == 'multiplelower') {
    return CalculationProgressOption.filter((f) => f.value != '3')
  }

  if (type == 'oldCascade') {
    return CalculationProgressOption.filter(
      (f) => f.value == '1' || f.value == '5' || f.value == '6'
    )
  }

  return ProgressTypeOptions
  //return getProgressTypeOptions()
}

export const getCalculationCascadeProgressOption = (type = '') => {
  const newCascadeProgressOption = [5, 6];
  if (window.wbConfig.isEnhancedCascadesEnabled) {
    newCascadeProgressOption.push(7);
  }
  if (type == 'new') {
    return CalculationCascadeProgressOption.filter(
      (f) => newCascadeProgressOption.includes(f.value)
    )
  }
  if (type == 'oldCascade') {
    return CalculationCascadeProgressOption.filter((f) => f.value == '1')
  }

  return CascadeProgressTypeOptions
}

export const getCountingText = (counting) => {
  const findText = getCoutingTargetOptions().find((f) => f.value == counting)
  return findText || ''
}

export const getWeekDay = (day) => {
  const findText = getWeekDaysOptions().find((d) => d.value == day)
  return findText ? findText.name : ''
}

export const getMetricTypeText = (metric) => {
  metric = metric == '0' ? 1 : metric
  const findText = getMetricTypeOptions().find((d) => d.value == metric)
  return findText ? findText.name : ''
}

export const getOrgEngTypeOptions = (year) => {
  if (year) {
    const OrgEngTypeOptionsAppent = [
      {
        value: 0,
        name: i18n.t('All Time'),
      },
      {
        value: 1,
        name: `Q1 ${year}`,
      },
      {
        value: 2,
        name: `Q2 ${year}`,
      },
      {
        value: 3,
        name: `Q3 ${year}`,
      },
      {
        value: 4,
        name: `Q4 ${year}`,
      },
      {
        value: 5,
        name: i18n.t('Custom time period'),
      },
    ]
    return OrgEngTypeOptionsAppent
  }
}

export const getCascacdeTargetValue = (type) => {
  if (type == 'new') {
    return CountingTargetOptions.filter((f) => f.value == '1' || f.value == '2')
  }
  if (type == 'old') {
    return CountingTargetOptions
  }
}
export const getIntervalOptions = (
  type = 'default',
  isEnabledBiweeklyKR = false,
  isOnceEnabled = false,
  isBiQuarterlySelected = false,
) => {
  let intervalArray = [...IntervalOptions()]
  if (isEnabledBiweeklyKR) {
    intervalArray.splice(2, 0, { value: 6, name: i18n.t('Bi-Weekly') })
  }
  if (isBiQuarterlySelected || wbConfig.isBiQuarterlyEnabled) {
    intervalArray.splice(4, 0, { value: 7, name: i18n.t('Bi-Quarterly') })
  }
  if (isOnceEnabled) {
    intervalArray.splice(0, 0, {
      value: 5,
      name: i18n.t('Once'),
    })
  }
  if (type == 'cascade') {
    return intervalArray
  }
  return intervalArray.filter((f) => f.value)
}

export const getProgressTypeOptions = () => ProgressTypeOptions
export const getMetricTypeOptions = () => MetricTypeOptions
export const getWeekDaysOptions = () => WeekDaysOptions()
export const getYesOrNoOptions = (interval) => {
  if (interval == 5) {
    return YesOrNoOptions.slice(0, 4)
  }
  return YesOrNoOptions
}
export const getCountingOptions = () => CountingOptions
export const getCoutingTargetOptions = () => CountingTargetOptions
export const getCascadeProgressTypeOptions = () => CascadeProgressTypeOptions
export const getProgressTypeCascadeOptions = () => ProgressTypeCascadeOptions

export const isWeeklyInterval = (interval) => interval == 2 || interval == 6

export const stripMitChildUnitOfMeasure = (childKrPayload) => {
  // Workstream children use metric as measure-as (e.g. % complete vs total),
  // not unit of measure — preserve it.
  // Lazy require avoids a circular import with krdetails.constants (it imports this module).
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  const { krdetailConstants } = require('../constants/krdetails.constants');
  if (
    childKrPayload &&
    Number(childKrPayload.source) !== krdetailConstants.SOURCE_WORKSTREAM &&
    Object.prototype.hasOwnProperty.call(childKrPayload, 'metric')
  ) {
    delete childKrPayload.metric;
  }
  return childKrPayload;
};

export default {
  getIntervalText,
  getMeasureDataOptions,
  getCalculationProgressOption,
  getProgressTypeOptions,
  getMetricTypeOptions,
  getIntervalOptions,
  getWeekDaysOptions,
  getYesOrNoOptions,
  getCountingOptions,
  getCoutingTargetOptions,
  getCascadeProgressTypeOptions,
  getCountingText,
  getWeekDay,
  getMetricTypeText,
  cascadeProgressTypeOptionsText,
  getProgressTypeCascadeOptions,
  getCalculationCascadeProgressOption,
  getOrgEngTypeOptions,
  getCascacdeTargetValue,
  isWeeklyInterval,
  stripMitChildUnitOfMeasure,
  WeekDaysOptionsText,
  IntervalTexts,
}
